import * as Color from 'core/colors';
import styled from 'styled-components';

export interface IButton {
  type?: 'button' | 'submit' | 'reset';
  targetRef?: any;
  text?: string;
  click: () => void;
  style?: any;
}

export const BaseButton = styled.button`
  color: white;
  background-color: ${Color.ceregoGreen};
  border: 1px solid ${Color.darkGreen};
  box-shadow: 0 1px 10px 0 ${Color.primaryGray};
  :hover {
    background-color: ${Color.ceregoGreen};
  }
  :focus {
    box-shadow: 0 1px 4px 0 ${Color.reportBlue};
  }
`;
